export const togglePlan = (selector) => {
  const togglePlanBtn = document.querySelector('.membership-toggle');

  if (!togglePlanBtn) {
    return;
  }

  togglePlanBtn.addEventListener('click', () => selector.classList.toggle('yearly'));
};
